module.exports = __webpack_public_path__ + "img/horizontal_4_3_0.6fff8c39.png";